import React from 'react'
import PropTypes from 'prop-types'
import {Box, Text} from '@chakra-ui/react'

const NumberAbsoluteIcon = ({number, ...props}) => {
    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            width="20px"
            height="20px"
            textAlign="center"
            borderRadius="50%"
            border="1px solid"
            borderColor="border.dark"
            boxSizing="border-box"
            flexShrink={0}
            {...props}
        >
            <Text fontSize="12px" fontWeight="normal" lineHeight="1" height="fit-content">
                {number}
            </Text>
        </Box>
    )
}

NumberAbsoluteIcon.propTypes = {
    number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default NumberAbsoluteIcon
